import React from 'react';
import { useSelector } from 'react-redux';
import { Card, Col, Row, Typography } from 'antd';

import {
  FinancialInstrument,
  HISTORICAL_SCENARIO,
  LIMIT_METRIC_CHOICES,
  selectors,
  TRADING_WINDOWS,
  UnderlyingAsset,
} from 'state';
import Overview from './Overview';
import ReturnByAssetClass from './ReturnByAssetClass';
import ReturnByRegion from './ReturnByRegion';
import ReturnByIndustry from './ReturnByIndustry';
import LimitsAndWeights from './LimitsAndWeights';
import BenchmarkComposition from './BenchmarkComposition';
import TradingWindows from './TradingWindows';
import Investments from './Investments';
import PortfolioLimits from './PortfolioLimits';
import ReturnBySector from './ReturnBySector';
import { formatters } from 'services';
// import MRRPlayerGraph from './MRRPlayerGraph';
import MRRPlayerGraph from './MRRPlayerGraphApexChartsReplacement';

export type InvestmentData = FinancialInstrument &
  UnderlyingAsset & {
    currency: string;
    reportingValue: number;
    dollarToPortfolioRatio: number;
  };

const PortfolioTab: React.FC = () => {
  const { scenario_type, trading_time_type, client_money } = useSelector(
    selectors.activeSession
  );
  const session = useSelector(selectors.activeSession);
  const assets = useSelector(selectors.underlyingAssets);
  const sessionHasNoEquities = Object.values(assets).every(
    asset => asset.resourcetype !== 'Equity'
  );

  return (
    <div style={{ display: 'flex', flexDirection: 'column', gap: 40 }}>
      <Row style={{ flexFlow: 'row nowrap' }} gutter={40}>
        <Col
          style={{
            display: 'flex',
            flexDirection: 'column',
            gap: 40,
            width: '100%',
            // backgroundColor: 'red',
          }}
        >
          <Overview />
          {/*CHANGED FROM HIGHCHARTS TO APEXCHARTS*/}
          {client_money && <MRRPlayerGraph />}
          <ReturnByAssetClass />
          <ReturnByRegion />
          {!sessionHasNoEquities && (
            <>
              <ReturnByIndustry />
              <ReturnBySector />
            </>
          )}
        </Col>

        <Col
          style={{
            width: 'min-content',
            display: 'flex',
            flexDirection: 'column',
            gap: 40,
            borderLeft: '1px solid #eeeeee',
          }}
        >
          {/*{scenario_type === HISTORICAL_SCENARIO && <PortfolioLimits />}*/}
          <PortfolioLimits />
          <LimitsAndWeights />
          <BenchmarkComposition />
          {trading_time_type === TRADING_WINDOWS && <TradingWindows />}
        </Col>
      </Row>

      <Investments />
    </div>
  );
};

export default PortfolioTab;
